import { defineStore } from 'pinia'
import client from '@/api/client'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('qc_token') || '',
    user: null,
    loading: false,
  }),
  getters: {
    isLoggedIn: (s) => !!s.token,
    isAdmin: (s) => s.user?.role === 'admin',
    displayName: (s) => s.user?.full_name || s.user?.username || '',
    mustResetPassword: (s) => !!s.user?.must_reset_password,

    // Phase 2.2 角色派生（与后端 admin 路由权限对齐）
    isLaukaaManager: (s) => s.user?.role === 'laukaa_manager',
    isSiilinjarviManager: (s) => s.user?.role === 'siilinjarvi_manager',
    isContentEditor: (s) => s.user?.role === 'content_editor',
    /** 该 manager 锁定的门店 ID（admin / content_editor 返回 null = 不锁定）。 */
    managedRestaurantId: (s) => s.user?.managed_restaurant_id ?? null,
    /** 能写菜品 / 营业时间：admin + 两个店 manager。 */
    canManageMenu: (s) =>
      ['admin', 'laukaa_manager', 'siilinjarvi_manager'].includes(s.user?.role),
    canManageHours: (s) =>
      ['admin', 'laukaa_manager', 'siilinjarvi_manager'].includes(s.user?.role),
    /** 能写周午餐表（含 content_editor）。 */
    canEditLounaslista: (s) =>
      ['admin', 'laukaa_manager', 'siilinjarvi_manager', 'content_editor'].includes(
        s.user?.role,
      ),
    /** 能写 CMS / 合作店 / B2B 产品（仅 admin + content_editor，manager 不管 B2B）。 */
    canEditCmsContent: (s) =>
      ['admin', 'content_editor'].includes(s.user?.role),

    // C8 · Omavalvonta 岗位标签（与 role 正交，用于前端默认路由）
    /** 厨房岗（默认进 /omv/sushi）。 */
    isKitchen: (s) => !!s.user?.is_kitchen,
    /** 送货员岗（默认进 /omv/driver）。 */
    isDriver: (s) => !!s.user?.is_driver,
  },
  actions: {
    async login(username, password) {
      this.loading = true
      try {
        const { data } = await client.post('/auth/login', { username, password })
        this.token = data.access_token
        this.user = data.user
        localStorage.setItem('qc_token', this.token)
        return data
      } finally {
        this.loading = false
      }
    },
    async fetchMe() {
      if (!this.token) return null
      const { data } = await client.get('/auth/me')
      this.user = data
      return data
    },
    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem('qc_token')
    },
  },
})
